<template>
  <div class="applicantInfo">
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>法人名称<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.corporateName"
          placeholder="请输入企业名称或机构名称"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>是否包含外资<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-radio-group v-model="form.nature"
          ><el-radio label="1">是</el-radio>
          <el-radio label="2">否</el-radio></el-radio-group
        >
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>备案域名<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <el-input
          v-model="form.domain"
          placeholder="请输入企业名称或机构名称"
        ></el-input>
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>营业执照扫描件<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <uploadFileList
          :successFile="successFile1"
          :imgData="imgData"
          typeFile="image"
          :actionUrl="actionUrl"
          :claim="claim1"
          :pFileList="fileList1"
          :fileLength="1"
        />
      </div>
    </div>
    <!--  -->
    <div class="applicantInfoFormItem">
      <div class="formItemLeftTitle">
        <p>域名证书<span>*</span></p>
      </div>
      <div class="formItemRightMain">
        <uploadFileList
          :successFile="successFile2"
          :imgData="imgData"
          typeFile="image"
          :actionUrl="actionUrl"
          :claim="claim2"
          :pFileList="fileList2"
          :fileLength="1"
        />
      </div>
    </div>
    <div class="formItemNext">
      <button @click="next">
        下一步
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getOss } from '@/api/tmTools.js';
import uploadFileList from '@/components/uploadFileList';
export default {
  data() {
    return {
      //表单绑定
      form: {
        corporateName: '', //法人名称
        nature: '1', //是否包含外资
        domain: '', //备案域名
      },
      //upLoadData
      imgData: {},
      actionUrl: '',
      //文件上传底部提示信息
      claim1: [
        {
          msg: '请上传jpg; jpeg格式的文件',
        },
      ],
      claim2: [
        {
          msg: '请上传jpg; jpeg格式的文件',
        },
      ],
      //文件列表
      fileList1: [],
      fileList2: [],
    };
  },
  components: {
    uploadFileList,
  },
  computed: {
    ...mapState({
      applicantInfo: (state) => state.alfillmaterials.applicantInfo,
    }),
  },
  mounted() {
    if (this.applicantInfo.saveed) {
      this.form = { ...this.applicantInfo.form };
      this.fileList1 = this.applicantInfo.fileList1;
      this.fileList2 = this.applicantInfo.fileList2;
    }
    this.$store.commit('alfillmaterials/changeActivedIndex', 0);
    getOss().then((res) => {
      if (res.status == 0) {
        this.actionUrl = res.data.url;
        this.imgData = res.data;
      }
    });
  },
  methods: {
    //下一页
    next() {
      if (!this.form.corporateName) {
        this.$message.warning('请输入法人名称！');
        return;
      } else if (!this.form.nature) {
        this.$message.warning('请选择是否包含外资！');
        return;
      } else if (!this.form.domain) {
        this.$message.warning('请输入备案域名！');
        return;
      } else if (!this.fileList1.length) {
        this.$message.warning('请上传营业执照扫描件！');
        return;
      } else if (!this.fileList2.length) {
        this.$message.warning('请上传域名证书！');
        return;
      }
      this.saveInfo();
      this.$router.push({
        path: '/alicpfillmaterials/personnel',
        query: { ...this.$route.query },
      });
    },
    //上传成功回调
    successFile1(file) {
      this.fileList1 = file;
    },
    successFile2(file) {
      this.fileList2 = file;
    },
    //保存vuex数据
    saveInfo() {
      let applicantInfoObj = {
        form: { ...this.form },
        fileList1: this.fileList1,
        fileList2: this.fileList2,
        saveed: true,
      };
      this.$store.commit(
        'alfillmaterials/saveAlApplicantInfo',
        applicantInfoObj
      );
    },
  },
};
</script>

<style lang="scss">
.applicantInfo {
  width: 100%;
  background: #fff;
  padding: 4px 0;
  margin-bottom: 60px;
  .applicantInfoFormItem {
    width: 100%;
    display: flex;
    padding: 16px;
    .formItemLeftTitle {
      width: 438px;
      height: 32px;
      p {
        text-align: right;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 32px;
        padding-right: 10px;
        span {
          color: #f00;
          margin-left: 5px;
          line-height: 32px;
        }
      }
    }
    .formItemRightMain {
      flex: 1;
      display: flex;
      align-items: center;
      .el-input {
        width: 435px;
        height: 32px;
        border-radius: 4px;
        input {
          width: 100%;
          height: 100%;
          font-size: 14px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          line-height: 22px;
          padding: 0 12px;
          border: 1px solid rgba(0, 0, 0, 0.15);
        }
      }
      & > span {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.85);
        line-height: 22px;
        margin-left: 10px;
      }
    }
    .el-radio__input.is-checked .el-radio__inner {
      background: #ff8a01;
      border: 1px solid #ff8a01;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #ff8a01;
    }
    .el-radio__inner:hover {
      border-color: #ff8a01;
    }
  }
  .formItemNext {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 40px;
    button {
      width: 154px;
      height: 36px;
      background: rgba(255, 138, 1, 1);
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 22px;
      border: none;
      cursor: pointer;
    }
    button:hover {
      opacity: 0.5;
    }
  }
}
</style>
